import React, { useEffect, useRef, useState } from "react";
import {
  Box,
  Button,
  IconButton,
  ThemeProvider,
  Typography,
} from "@mui/material";

import { MuiTheme } from "../styles/MuiDataTableStyle";
import Reports from "./reports";
import { useStateReportValue } from "../context/Reports";
import { element } from "prop-types";
import encode from "jwt-encode";
import { Await, useLocation } from "react-router-dom";
import { ArrowBack } from "@mui/icons-material";
import { getAllReports } from "../services/reportsService";
import { useStateAuthValue } from "../context/AuthState";
import { showToast, ToastType } from "../utils/ToastUtil";
import { useToast } from "../context/Toast/ToastProvider";
import NewSaleTMotos from "./newSaleTMotos";
import GenericDashboard from "./genericDashboard";

const TmotosDashboard = () => {
  const buttonsList = [
    { label: "Ventas", reportName: "Registros Ventas TMotos" },
    { label: "Graficos de venta por dia", reportName: "Ventas por Dia" },
    { label: "Graficos de venta por mes", reportName: "Ventas por Mes" },
    { label: "Error de Datos", reportName: "Error Triunfo Motos" },
    { label: "Alta de socio", reportName: "NEW-SALE-TMOTOS" },
  ];

  const extraViews = {
    "NEW-SALE-TMOTOS": <NewSaleTMotos />,
  };
  return (
    <GenericDashboard
      extraViews={extraViews}
      title={"Gestion de TMOTOS"}
      buttonsList={buttonsList}
    />
  );
};

export default TmotosDashboard;
